module.exports = __webpack_public_path__ + "static/img/5214_phase_function_Paper_PointsHejduk_Prediction.03a5cc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5214_phase_function_Paper_PointsHejduk_Prediction.png
// module id = EO6K
// module chunks = 0